module.exports = __webpack_public_path__ + "assets/img/2405.c6abfccc.png";